// src/offers/segments.ts
var OFFER_SEGMENTS = Object.freeze([
  "TRIAL_DAY_AT_LEAST",
  "TRIAL_ENDING_WITHIN",
  "TRIAL_EXPIRED_UNPAID_WITHIN",
  "CHURNED_WITHIN",
  "PAST_DUE",
  "ON_PLAN_FOR"
]);
var DAY_MS = 864e5;
var MONTH_MS = 30 * DAY_MS;
var NEEDS_DAYS = /* @__PURE__ */ new Set([
  "TRIAL_DAY_AT_LEAST",
  "TRIAL_ENDING_WITHIN",
  "TRIAL_EXPIRED_UNPAID_WITHIN",
  "CHURNED_WITHIN"
]);
var posInt = (v, max) => typeof v === "number" && Number.isInteger(v) && v >= 1 && v <= max ? v : null;
function parseAudienceRule(input) {
  if (!input || typeof input !== "object") return null;
  const o = input;
  if (!OFFER_SEGMENTS.includes(o.segment)) return null;
  const segment = o.segment;
  if (NEEDS_DAYS.has(segment)) {
    const days = posInt(o.days, 365);
    return days === null ? null : { segment, days };
  }
  if (segment === "ON_PLAN_FOR") {
    const months = posInt(o.months, 60);
    const planKeys = Array.isArray(o.planKeys) && o.planKeys.every((k) => typeof k === "string") ? o.planKeys : null;
    if (months === null || !planKeys || planKeys.length === 0) return null;
    return { segment, months, planKeys };
  }
  return { segment };
}
function segmentStatuses(rule) {
  switch (rule.segment) {
    case "TRIAL_DAY_AT_LEAST":
    case "TRIAL_ENDING_WITHIN":
      return ["TRIALING"];
    case "TRIAL_EXPIRED_UNPAID_WITHIN":
      return ["EXPIRED", "CANCELED"];
    case "CHURNED_WITHIN":
      return ["CANCELED", "EXPIRED"];
    case "PAST_DUE":
      return ["PAST_DUE"];
    case "ON_PLAN_FOR":
      return ["ACTIVE"];
  }
}
function segmentMatches(rule, s, now) {
  if (!segmentStatuses(rule).includes(s.status)) return false;
  const t = now.getTime();
  const days = (rule.days ?? 0) * DAY_MS;
  switch (rule.segment) {
    case "TRIAL_DAY_AT_LEAST":
      return !!s.trialStartedAt && t - s.trialStartedAt.getTime() >= days;
    case "TRIAL_ENDING_WITHIN":
      return !!s.trialEndsAt && s.trialEndsAt.getTime() > t && s.trialEndsAt.getTime() - t <= days;
    case "TRIAL_EXPIRED_UNPAID_WITHIN": {
      const ended = s.endedAt ?? s.trialEndsAt;
      return !s.hasPaid && !!ended && ended.getTime() <= t && t - ended.getTime() <= days;
    }
    case "CHURNED_WITHIN":
      return s.hasPaid && !!s.endedAt && t - s.endedAt.getTime() <= days;
    case "PAST_DUE":
      return true;
    case "ON_PLAN_FOR":
      return !!s.planKey && (rule.planKeys ?? []).includes(s.planKey) && !!s.paidSince && t - s.paidSince.getTime() >= (rule.months ?? 0) * MONTH_MS;
  }
}

// src/offers/copy.ts
var OFFER_COPY_TOKENS = Object.freeze([
  "percent",
  "amount",
  "cap",
  "freeMonths",
  "trialDays",
  "smsCredit",
  "endsAt",
  "cycles"
]);
var ANY_DIGIT = /[0-9۰-۹٠-٩]/;
var TOKEN = /\{([a-zA-Z]+)\}/g;
function offerCopyProblem(text) {
  if (ANY_DIGIT.test(text)) return "DIGITS";
  for (const m of text.matchAll(TOKEN)) {
    if (!OFFER_COPY_TOKENS.includes(m[1])) return "UNKNOWN_TOKEN";
  }
  return null;
}
function splitOfferCopy(text) {
  const out = [];
  let last = 0;
  for (const m of text.matchAll(TOKEN)) {
    const at = m.index ?? 0;
    if (at > last) out.push({ kind: "text", value: text.slice(last, at) });
    if (OFFER_COPY_TOKENS.includes(m[1])) out.push({ kind: "token", token: m[1] });
    else out.push({ kind: "text", value: m[0] });
    last = at + m[0].length;
  }
  if (last < text.length) out.push({ kind: "text", value: text.slice(last) });
  return out;
}

export { OFFER_COPY_TOKENS, OFFER_SEGMENTS, offerCopyProblem, parseAudienceRule, segmentMatches, segmentStatuses, splitOfferCopy };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map